import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "../../components/Button";
import DropDown from "../../components/DropDown/DropDown";
import Input from "../../components/Input/Input";
import ModalSkeleton from "../../components/ModalSkeleton";
import { Active, Deactivated } from "../../constant/imagePath";
import classes from "./AddEditUserModal.module.css";
import { mergeClass } from "../../utils/helper";
import { useFormik } from "formik";
import { EditUserInitialValues } from "../../data/initial-values";
import { EditUserSchema } from "../../schema/EditUserDataSchema";
import { Radio } from "@/components/Radio";

export default function AddEditUserModal({
  title,
  setShow,
  show,
  handleUserData,
  data,
  userRolesArray = [],
  loading = false,
}) {
  const editUserFormik = useFormik({
    initialValues: EditUserInitialValues,
    validationSchema: EditUserSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    await handleUserData(values);
  };

  useEffect(() => {
    if (data) {
      editUserFormik.setValues({
        firstName: data?.first_name,
        lastName: data?.last_name,
        email: data?.email,
        status: data?.status === "active" ? true : false,
        id: data?.id,
        ids: data?.ids,
        ...(data?.roles &&
          data?.roles.length > 0 && {
            userRole: data?.roles.map((role) => {
              return userRolesArray.find((userRole) => {
                return userRole.ids === role.ids;
              });
            }),
          }),
      });
    }
  }, [data]);

  return (
    <div>
      <ModalSkeleton
        header={title}
        setShow={setShow}
        show={show}
        modalStyles={classes.modal}
        showCloseIcon={true}
      >
        <div className={classes.formDiv}>
          <Row
            style={{
              rowGap: 20,
              marginInlineStart: "7px",
            }}
          >
            <Col md={12}>
              <Input
                showRainbowBorder={true}
                labelClass={classes.label}
                label={"First Name"}
                className={classes.inputAndDropdownConatiner}
                placeholder={"First Name"}
                inputContainerClass={classes.input}
                value={editUserFormik?.values?.firstName}
                setValue={(val) =>
                  editUserFormik?.setFieldValue("firstName", val)
                }
                errorTextClass={classes.errorText}
                errorText={
                  editUserFormik?.touched?.firstName &&
                  editUserFormik?.errors?.firstName
                }
              />
            </Col>

            <Col md={12}>
              <Input
                showRainbowBorder={true}
                errorTextClass={classes.errorText}
                labelClass={classes.label}
                placeholder={"Last Name"}
                label={"Last Name"}
                className={classes.inputAndDropdownConatiner}
                inputContainerClass={classes.input}
                value={editUserFormik?.values?.lastName}
                setValue={(val) =>
                  editUserFormik?.setFieldValue("lastName", val)
                }
                errorText={
                  editUserFormik?.touched?.lastName &&
                  editUserFormik?.errors?.lastName
                }
              />
            </Col>

            <Col md={12}>
              <Input
                showRainbowBorder={true}
                labelClass={classes.label}
                placeholder={"enter email"}
                label={"Email"}
                errorTextClass={classes.errorText}
                className={classes.inputAndDropdownConatiner}
                inputContainerClass={classes.input}
                value={editUserFormik?.values?.email}
                setValue={(val) => editUserFormik?.setFieldValue("email", val)}
                errorText={
                  editUserFormik?.touched?.email &&
                  editUserFormik?.errors?.email
                }
                disabled={data?.email}
              />
            </Col>

            <Col md={3}>
              <div className={classes.inputAndDropdownConatiner}>
                <label className={classes.label}>Status</label>
                <div className={classes.radioGroup}>
                  {radioOptions?.map((option) => (
                    <label
                      key={option.value}
                      className={classes.radioButton}
                      onClick={() => {
                        editUserFormik.setFieldValue("status", option.value);
                      }}
                    >
                      <input
                        className={classes.radioInput}
                        type="radio"
                        name="status"
                        value={editUserFormik?.values?.status}
                        checked={editUserFormik.values.status === option.value}
                      />
                      <span
                        htmlFor={`radio${option?.label}`}
                        className={` ${classes.radioContainer}`}
                      ></span>
                      <div
                        className={`${classes.customRadio} ${
                          option.value === true
                            ? `${mergeClass(classes.status, "active-status")}`
                            : `${mergeClass(classes.status, "deActive-status")}`
                        }`}
                      >
                        <img src={option.imageSrc} alt={option.label} />
                        <span>{option?.label}</span>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                {editUserFormik.touched.status &&
                  editUserFormik?.errors?.status && (
                    <div className={classes.error}>
                      {editUserFormik.touched.status &&
                        editUserFormik?.errors?.status}
                    </div>
                  )}
              </div>
            </Col>
            {/* <Col md={9}>
              <div className={classes.statusDiv}>
                {radioOptions?.map((e) => {
                  return (
                    <Radio
                      key={e?.label}
                      value={
                        editUserFormik.values.status ? "Active" : "Deactivated"
                      }
                      label={e?.label}
                      setValue={(val) => {
                        editUserFormik.setFieldValue(
                          "status",
                          val === "Active"
                        );
                       
                      }}
                    />
                  );
                })}
              </div>
              <div>
                {editUserFormik.touched.status &&
                  editUserFormik?.errors?.status && (
                    <div className={classes.error}>
                      {editUserFormik.touched.status &&
                        editUserFormik?.errors?.status}
                    </div>
                  )}
              </div>
            </Col> */}

            <Col md={12}>
              <DropDown
                menuPlacement={"top"}
                placeholder={"Any"}
                label={"User Role"}
                options={userRolesArray}
                optionLabel={"name"}
                optionValue={"id"}
                isMulti={true}
                mainClass={mergeClass(
                  classes.dropDownContainer,
                  classes.inputAndDropdownConatiner
                )}
                value={editUserFormik?.values?.userRole}
                setValue={(val) =>
                  editUserFormik?.setFieldValue("userRole", val)
                }
                errorTextClass={classes.errorText}
                errorText={
                  editUserFormik?.touched?.userRole &&
                  editUserFormik?.errors?.userRole
                }
              />
            </Col>

            <Col xs={6} className="mt-2">
              <Button
                variant={"outlined"}
                label={"Cancel"}
                onClick={() => setShow(null)}
                className={mergeClass(classes.buttonOne, classes.button)}
                disabled={loading}
              />
            </Col>
            <Col xs={6} className="mt-2">
              <Button
                onClick={() => editUserFormik?.handleSubmit()}
                variant={"green-gradient"}
                type={"submit"}
                label={`${loading ? "Saving..." : "Save"}`}
                className={mergeClass(classes.buttonTwo, classes.button)}
                disabled={loading}
              />
            </Col>
          </Row>
        </div>
      </ModalSkeleton>
    </div>
  );
}

const radioOptions = [
  { value: true, label: "Active", imageSrc: Active, defaultChecked: true },
  {
    value: false,
    label: "Deactivated",
    imageSrc: Deactivated,
    defaultChecked: false,
  },
];
